var _path, _path2, _line, _path3, _path4, _line2, _path5, _path6, _line3, _path7, _path8, _line4, _path9, _path10, _line5, _path11, _path12, _line6, _path13, _path14, _line7, _path15, _path16, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHerb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "herb1",
    d: "M354.34,348.91c-39.52-14.82-66.55-49.85-82.39-77-11.62-19.89-2.59-43.95,19.24-51.3,29.75-10,73.15-18.63,112.67-3.82s66.55,49.85,82.39,77c11.62,19.88,2.6,43.94-19.24,51.29C437.26,355.1,393.86,363.72,354.34,348.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M354.34,348.91c-39.52-14.82-66.55-49.85-82.39-77-11.62-19.89-2.59-43.95,19.24-51.3,29.75-10,73.15-18.63,112.67-3.82s66.55,49.85,82.39,77c11.62,19.88,2.6,43.94-19.24,51.29C437.26,355.1,393.86,363.72,354.34,348.91Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 269.03,
    y1: 241.61,
    x2: 386.85,
    y2: 285.78
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "herb1",
    d: "M290.8,90.79c-30.14,29.55-40.67,72.52-44.19,103.72C244,217.4,262,235.75,285,233.63c31.26-2.89,74.44-12.57,104.58-42.12S430.21,119,433.72,87.79c2.58-22.88-15.41-41.23-38.35-39.11C364.11,51.57,320.94,61.25,290.8,90.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M290.8,90.79c-30.14,29.55-40.67,72.52-44.19,103.72C244,217.4,262,235.75,285,233.63c31.26-2.89,74.44-12.57,104.58-42.12S430.21,119,433.72,87.79c2.58-22.88-15.41-41.23-38.35-39.11C364.11,51.57,320.94,61.25,290.8,90.79Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 256.22,
    y1: 223.45,
    x2: 346.08,
    y2: 135.36
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "herb1",
    d: "M244.93,86.83c24.62,34.28,27.62,78.42,25.72,109.76-1.39,23-22.26,38-44.49,31.95-30.3-8.21-71.17-25.16-95.79-59.44S102.75,90.67,104.65,59.33c1.39-23,22.26-38,44.49-31.95C179.44,35.6,220.31,52.55,244.93,86.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M244.93,86.83c24.62,34.28,27.62,78.42,25.72,109.76-1.39,23-22.26,38-44.49,31.95-30.3-8.21-71.17-25.16-95.79-59.44S102.75,90.67,104.65,59.33c1.39-23,22.26-38,44.49-31.95C179.44,35.6,220.31,52.55,244.93,86.83Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 256.22,
    y1: 223.45,
    x2: 182.82,
    y2: 121.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "herb1",
    d: "M131,329.81c42.09-3,77.95-28.94,100.82-50.44,16.78-15.77,15-41.41-3.9-54.64-25.7-18-64.88-38.61-107-35.6S43,218.07,20.16,239.57c-16.79,15.78-15,41.41,3.9,54.64C49.75,312.24,88.93,332.82,131,329.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M131,329.81c42.09-3,77.95-28.94,100.82-50.44,16.78-15.77,15-41.41-3.9-54.64-25.7-18-64.88-38.61-107-35.6S43,218.07,20.16,239.57c-16.79,15.78-15,41.41,3.9,54.64C49.75,312.24,88.93,332.82,131,329.81Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 243.26,
    y1: 251.1,
    x2: 117.74,
    y2: 260.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "herb1",
    d: "M181.34,369.34c-7.05-41.61,9.66-82.58,25.14-109.9,11.36-20,36.7-24.32,54-9.14,23.61,20.7,52.87,53.89,59.91,95.5s-9.66,82.59-25.14,109.9c-11.36,20-36.7,24.33-54,9.14C217.64,444.14,188.38,411,181.34,369.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M181.34,369.34c-7.05-41.61,9.66-82.58,25.14-109.9,11.36-20,36.7-24.32,54-9.14,23.61,20.7,52.87,53.89,59.91,95.5s-9.66,82.59-25.14,109.9c-11.36,20-36.7,24.33-54,9.14C217.64,444.14,188.38,411,181.34,369.34Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 231.25,
    y1: 241.66,
    x2: 252.25,
    y2: 365.74
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "herb3",
    d: "M343.5,214.91c-20.7,20.7-50.59,27.71-72.25,29.93-15.89,1.63-28.5-11-26.87-26.87,2.22-21.66,9.23-51.54,29.94-72.24S324.9,118,346.56,115.79c15.9-1.63,28.5,11,26.87,26.87C371.21,164.32,364.2,194.21,343.5,214.91Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M343.5,214.91c-20.7,20.7-50.59,27.71-72.25,29.93-15.89,1.63-28.5-11-26.87-26.87,2.22-21.66,9.23-51.54,29.94-72.24S324.9,118,346.56,115.79c15.9-1.63,28.5,11,26.87,26.87C371.21,164.32,364.2,194.21,343.5,214.91Z"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 251.25,
    y1: 237.98,
    x2: 312.97,
    y2: 176.26
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "herb3",
    d: "M307.75,323.41C306.93,294.15,290,268.53,275.8,252c-10.43-12.11-28.25-11.6-38,1.07-13.26,17.27-28.69,43.8-27.87,73.07s17.73,54.88,32,71.38c10.43,12.1,28.25,11.59,38-1.08C293.15,379.21,308.58,352.68,307.75,323.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M307.75,323.41C306.93,294.15,290,268.53,275.8,252c-10.43-12.11-28.25-11.6-38,1.07-13.26,17.27-28.69,43.8-27.87,73.07s17.73,54.88,32,71.38c10.43,12.1,28.25,11.59,38-1.08C293.15,379.21,308.58,352.68,307.75,323.41Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 256.55,
    y1: 243.28,
    x2: 259.01,
    y2: 330.54
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "herb3",
    d: "M165.81,184.12c29.26.83,54.88,17.73,71.38,31.95,12.1,10.43,11.6,28.25-1.08,38-17.26,13.27-43.8,28.7-73.06,27.87S108.16,264.19,91.67,250c-12.1-10.44-11.6-28.26,1.07-38C110,198.73,136.54,183.3,165.81,184.12Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "herb2",
    d: "M165.81,184.12c29.26.83,54.88,17.73,71.38,31.95,12.1,10.43,11.6,28.25-1.08,38-17.26,13.27-43.8,28.7-73.06,27.87S108.16,264.19,91.67,250c-12.1-10.44-11.6-28.26,1.07-38C110,198.73,136.54,183.3,165.81,184.12Z"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "herb2",
    x1: 245.94,
    y1: 235.33,
    x2: 158.69,
    y2: 232.86
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerb);
export default __webpack_public_path__ + "static/media/Herb.12b5e35199eb30d7202ef0c3bc6b2b08.svg";
export { ForwardRef as ReactComponent };